import type { ExecutionChatHitlRequestCas } from '@shared/types/execution-chat';

export const attachExecutionChatHitlCas = <T extends object>(
  payload: T,
  hitlRequestCas: ExecutionChatHitlRequestCas | null,
): T & { hitlRequestCas?: ExecutionChatHitlRequestCas } => ({
  ...payload,
  ...(hitlRequestCas ? { hitlRequestCas } : {}),
});
